import { pool } from './pool';
export function reduceLogSum(a, axes, keepDims) {
    return pool(a, axes, (a, b) => {
        return a + (b !== undefined ? b : 0);
    }, keepDims, (a) => Math.log(a));
}
//# sourceMappingURL=reduceLogSum.js.map